import { JSONPath } from "jsonpath-plus";
export const tokenBreakpoints = ["xSmall", "small", "medium", "large", "xLarge"];
const cssUnit = /([.\d]+)([a-zA-Z])+/;
export const stripUnit = (str) => {
    if (typeof str !== "string")
        return 0;
    return Number(str.replace(cssUnit, "$1"));
};
export const stripUnitFromObject = (obj) => {
    const stripped = Object.assign(Object.assign({}, Object.create({})), obj);
    for (const [key, value] of Object.entries(stripped)) {
        if (typeof value === "string") {
            stripped[key] = Number(value.replace(cssUnit, "$1"));
        }
    }
    return stripped;
};
export const resolve = (obj, arr, arr2) => {
    let returnVar = obj;
    for (const item of arr) {
        if (returnVar[item]) {
            returnVar = returnVar[item];
        }
    }
    if (arr2) {
        return resolve(returnVar, arr2);
    }
    return returnVar;
};
export const transition = (cssProps, state) => {
    if (typeof cssProps === "string" && cssProps.length > 0) {
        return `${cssProps} ${!state || state === "default" ? "0.15s" : "0.01s"} ease-in-out`;
    }
    if (typeof cssProps === "object") {
        const transitions = [];
        for (const cssProp of cssProps) {
            transitions.push(`${cssProp} ${!state || state === "default" ? "0.15s" : "0.01s"} ease-in-out`);
        }
        return transitions.join(",");
    }
    return "inherit";
};
export const getHighestSpreadRadiusinPxFromBoxShadow = (str) => {
    const sizes = str.match(/\d+(px)? \d+(px)? \d+(px)? (\d+)px/g);
    if (typeof str === "string" && !!sizes) {
        const sizesInt = sizes.map((x) => {
            const spreadVal = x.match(/(\d+)(px)$/);
            if (!spreadVal) {
                return 0;
            }
            return Number.parseInt(spreadVal[0], 10);
        });
        return Math.max(...sizesInt);
    }
    return 0;
};
export const getResponsiveToken = (dt, path) => {
    if (!dt || !path) {
        console.info("getResponsiveToken: No design tokens object or path provided.");
        return;
    }
    const varDefault = JSONPath({ path: path, json: dt });
    const varXsmall = JSONPath({ path: `responsive.xSmall.${path}`, json: dt });
    if (varDefault.length !== 1) {
        console.info("getResponsiveToken: path does not exist.");
        return;
    }
    const vars = {
        default: varDefault[0],
    };
    if (varXsmall.length === 1) {
        vars.xSmall = varXsmall[0];
    }
    return vars;
};
